import { ParcelService } from './parcel-service';

let parcelService = new ParcelService();

export { parcelService }